import { turboproApiLista } from '@/api/turbopro';
import type {
  AgendamentoApi,
  ListarAgendamentosPeriodoFiltros,
  ListarAgendamentosPeriodoResponse,
} from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listarAgendamentosPeriodoApi(
  filtros: ListarAgendamentosPeriodoFiltros
): Promise<ListarAgendamentosPeriodoResponse> {
  // POST com body, não GET com querystring — confirmado no Swagger real.
  const resposta = await turboproApiLista<AgendamentoApi>('Relatorios/ListarAgendamentosPeriodo', {
    method: 'POST',
    body: {
      CNPJ_Contribuinte: filtros.cnpjContribuinte,
      Data: filtros.data,
    },
    headers: getRelatoriosHeaders(),
  });
  return resposta.data ?? [];
}
